import { createImage } from './CropImageHelper';

const getCroppedImg = async (imageSrc, pixelCrop, options = {}) => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  const { maxSize, quality } = options;

  let canvasWidth = pixelCrop.width;
  let canvasHeight = pixelCrop.height;
  let drawWidth = pixelCrop.width;
  let drawHeight = pixelCrop.height;

  // If maxSize is specified, scale down if needed (never upscale)
  if (maxSize) {
    const maxDimension = Math.max(pixelCrop.width, pixelCrop.height);
    if (maxDimension > maxSize) {
      const scaleFactor = maxSize / maxDimension;
      canvasWidth = Math.round(pixelCrop.width * scaleFactor);
      canvasHeight = Math.round(pixelCrop.height * scaleFactor);
      drawWidth = canvasWidth;
      drawHeight = canvasHeight;
    }
  }

  canvas.width = canvasWidth;
  canvas.height = canvasHeight;

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    drawWidth,
    drawHeight
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob((file) => {
      if (!file) {
        reject(new Error('Canvas is empty'));
        return;
      }

      resolve(file);
    }, 'image/jpeg', quality);
  });
};

export default getCroppedImg;
